export default __webpack_public_path__ + "static/media/other-goal.bae7db52.svg";